import { useMemo } from 'react';

import { growthService } from '../../../../services';
import { createApiSlice } from '../../utils/createApiSlice';

const createActivityFeedbackSlice = createApiSlice({
  reducerPath: ['newGrowths', 'activities', 'createActivityFeedback'],
  apiFunction: growthService.createActivityFeedbackV2
});

const { actions, useApiSelectors } = createActivityFeedbackSlice;

export const createActivityFeedbackActions = actions;

export const useCreateActivityFeedbackSelectors = () => {
  const { inProgress, errorMessage, success, updatedAt } = useApiSelectors();

  return useMemo(
    () => ({
      inProgress,
      errorMessage,
      success,
      updatedAt
    }),
    [errorMessage, inProgress, success, updatedAt]
  );
};

export default createActivityFeedbackSlice;
